// extracted by css-extract-rspack-plugin
export default {"rtlTransform":"rtlTransform-aPQFZt","large":"large-sA99L4"};